<template>
    <div class="super-menu" :class="{ disabled: !value.enabled }">
        <div class="super-tabs">
            <div class="left">
                <div
                    class="super-tab"
                    :class="{ selected: currentTab === 'canned-messages' }"
                    @click="changeTab('canned-messages')"
                >
                    <ReadyContentsSvg />
                    Canned Messages
                </div>
                <!--                <div class="super-tab" :class="{ selected: currentTab === 'commands' }" @click="changeTab('commands')">-->
                <!--                    <ReadyContentsSvg />-->
                <!--                    Commands-->
                <!--                </div>-->
                <!--                <div-->
                <!--                    class="super-tab"-->
                <!--                    :class="{ selected: currentTab === 'variables' }"-->
                <!--                    @click="changeTab('variables')"-->
                <!--                >-->
                <!--                    <ReadyContentsSvg />-->
                <!--                    Variables-->
                <!--                </div>-->
                <!--                <div class="super-tab" :class="{ selected: currentTab === 'co-pilot' }" @click="changeTab('co-pilot')">-->
                <!--                    <ReadyContentsSvg />-->
                <!--                    Co Pilot-->
                <!--                </div>-->
                <!--                <div class="super-tab" :class="{ selected: currentTab === 'chatbot' }" @click="changeTab('chatbot')">-->
                <!--                    <ReadyContentsSvg />-->
                <!--                    Chatbot-->
                <!--                </div>-->
            </div>
            <div class="right">
                <SupsisButton icon @click="close">
                    <div class="material-icons">close</div>
                </SupsisButton>
            </div>
        </div>
        <div class="super-menu-content">
            <CannedMessageSelector
                v-if="currentTab === 'canned-messages'"
                :default-search="value.text"
                :type="value.type"
                @selected="selected"
                :contact="contact"
            />
            <!--            <Commands-->
            <!--                v-else-if="currentTab === 'commands'"-->
            <!--                :default-command="value.command"-->
            <!--                :value="value.text"-->
            <!--                @selected="selected"-->
            <!--            />-->
            <!--            <div v-else-if="currentTab === 'variables'">Variables</div>-->
            <!--            <div v-else-if="currentTab === 'co-pilot'">Co Pilot</div>-->
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import ReadyContentsSvg from "../../../svg/ReadyContentsSvg.vue";
import SupsisButton from "../../../../../../views/Pages/Settings/components/SupsisButton.vue";
import CannedMessageSelector from "./CannedMessageSelector.vue";
import log2 from "../../../../../../utils/log2";
import Commands from "./Commands.vue";
import SYSTEM_PUBSUB from "../../../../../../utils/systemPubSub";

const log = log2("SuperMenu");
export default Vue.extend({
    name: "SuperMenu",
    components: { Commands, CannedMessageSelector, SupsisButton, ReadyContentsSvg },
    props: {
        value: {
            type: Object,
            default: () => ({
                enabled: false,
                command: null,
                text: null,
                type: null, // canned-messages-hash, canned-messages-tab, commands, variables, co-pilot, chatbot
            }),
        },
        contact: {
            type: Object,
        },
    },
    data() {
        return {
            currentTab: "canned-messages",
            cancels: [],
        };
    },
    created() {
        this.switchContextByType(this.value.type);
        const keydownCallback = (e) => {
            if (e.key === "Escape") {
                this.close();
            }
        };
        window.addEventListener("keydown", keydownCallback);
        this.cancels.push(() => {
            window.removeEventListener("keydown", keydownCallback);
        });
    },
    methods: {
        changeTab(tab) {
            this.currentTab = tab;
        },
        close() {
            this.$emit("updateSuperMenuState", { ...this.value, enabled: false });
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.SUPER_MENU_ACTION_SELECTED, {});
        },
        switchContextByType(type) {
            type = type || "";
            let result = this.currentTab;
            if (type === "") {
                result = "canned-messages";
            } else if ((type || "").startsWith("canned-messages")) {
                result = "canned-messages";
            } else if ((type || "").startsWith("commands")) {
                result = "commands";
            } else if ((type || "").startsWith("variables")) {
                result = "variables";
            } else if ((type || "").startsWith("co-pilot")) {
                result = "co-pilot";
            }
            result = result || "canned-messages";

            if (result !== this.currentTab) {
                this.currentTab = result;
            }

            log("switchContextByType", type, result, this.currentTab);
        },
        selected(data) {
            log("selected", data);
            data.contact = this.contact;
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.SUPER_MENU_ACTION_SELECTED, data);
            if (this.currentTab === "canned-messages") {
            } else if (this.currentTab === "commands") {
                this.$emit("used-command", data);
            }
            this.close();
        },
    },

    watch: {
        value: {
            handler(newVal) {
                this.switchContextByType(newVal.type);
            },
            immediate: true,
            deep: true,
        },
    },
    beforeDestroy() {
        log("beforeDestroy");
        this.cancels.forEach((cancel) => cancel());
    },
});
</script>

<style scoped lang="scss">
.super-menu {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-weight: 500;
    background-color: #e9ecef;
    height: 300px;
    max-height: 600px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    width: 100%;
    border-bottom: 1px solid #ccc;

    &.disabled {
        display: none;
    }

    .super-tabs {
        display: flex;
        justify-content: space-between;
        background-color: #f1f4f7;
        width: 100%;
        height: 40px;

        .left {
            display: flex;

            .super-tab {
                display: flex;
                gap: 3px;
                align-items: center;
                padding: 10px 20px;
                cursor: pointer;
                font-size: 12px;

                &:hover {
                    background-color: #f5f5f5;
                }

                &.selected {
                    background-color: #e9ecef;
                }
            }
        }

        .right {
            display: flex;
            align-items: center;
        }
    }

    .super-menu-content {
        height: 100%;
        max-height: calc(100% - 40px);
        overflow: hidden;
        min-height: inherit;
    }
}
</style>
